var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNigeria({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3346_2044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 1.35103C22.3139 1.35155 22.6743 1.50113 22.9401 1.76694C23.2059 2.03276 23.3555 2.39313 23.356 2.76904V22.645C23.3555 23.0209 23.2059 23.3813 22.9401 23.6471C22.6743 23.9129 22.3139 24.0625 21.938 24.063H2.06201C1.6861 24.0625 1.32572 23.9129 1.05991 23.6471C0.7941 23.3813 0.644523 23.0209 0.643994 22.645V2.76904C0.644523 2.39313 0.7941 2.03276 1.05991 1.76694C1.32572 1.50113 1.6861 1.35155 2.06201 1.35103H21.938ZM21.938 0.707031H2.06201C1.5153 0.707561 0.991126 0.924987 0.604541 1.31157C0.217956 1.69816 0.000529505 2.22233 0 2.76904V22.645C0.000529505 23.1917 0.217956 23.7159 0.604541 24.1025C0.991126 24.4891 1.5153 24.7065 2.06201 24.707H21.938C22.4845 24.706 23.0084 24.4884 23.3949 24.1019C23.7814 23.7155 23.9989 23.1916 24 22.645V2.76904C23.9995 2.22233 23.782 1.69816 23.3955 1.31157C23.0089 0.924987 22.4847 0.707561 21.938 0.707031Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4534 0.707031H17V24.707H22.4534C22.8634 24.7065 23.2565 24.5484 23.5464 24.2675C23.8363 23.9866 23.9994 23.6058 24 23.2086V2.20546C23.9994 1.80823 23.8363 1.42742 23.5464 1.14654C23.2565 0.86565 22.8634 0.70759 22.4534 0.707031Z",
    fill: "#00874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5466 0.707031C1.1366 0.70759 0.743549 0.86565 0.453633 1.14654C0.163718 1.42742 0.000577062 1.80823 0 2.20546V23.2086C0.000577062 23.6058 0.163718 23.9866 0.453633 24.2675C0.743549 24.5484 1.1366 24.7065 1.5466 24.707H7V0.707031H1.5466Z",
    fill: "#00874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 0.707031H7V24.707H17V0.707031Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3346_2044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.707031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeria);
export default __webpack_public_path__ + "static/media/Nigeria.b5173bbe8dff9604b9a708ab3328182f.svg";
export { ForwardRef as ReactComponent };